// extracted by mini-css-extract-plugin
export var addToCartButton = "_tr-b";
export var arrowButtonContainer = "_tr-9";
export var arrowButtonIcon = "_tr-a";
export var carouselArrowButton = "_tr-6";
export var carouselElementContainer = "_tr-1";
export var left = "_tr-7";
export var productDisplayCarouselContainer = "_tr-0";
export var productTileContainer = "_tr-2";
export var productTileImage = "_tr-4";
export var productTileImageContainer = "_tr-3";
export var productTileTitle = "_tr-5";
export var right = "_tr-8";
export var sliderOverflow = "_tr-c";